import { requestWithPromise } from '..'
import { DELETE, GET, PATCH, POST, makeQueryString } from '../apiHelper'

export const createSectorShiftPreset = (user, sector, shiftPreset) => {
  return requestWithPromise(
    `/api/sectors/${sector.id}/shift-presets`,
    POST,
    shiftPreset.toRequestBody(),
    user,
    true,
    true
  )
}

export const createDeletedSectorShiftPreset = (user, sector, shiftPreset) => {
  const body = shiftPreset.toRequestBody()
  body.deleted = true

  return requestWithPromise(
    `/api/sectors/${sector.id}/shift-presets`,
    POST,
    body,
    user,
    true,
    true
  )
}

export const updateShiftPreset = (user, shiftPreset) => {
  return requestWithPromise(
    `/api/shift-presets/${shiftPreset.id}`,
    PATCH,
    shiftPreset.toRequestBody(),
    user,
    true,
    true
  )
}

export const deleteShiftPreset = (user, shiftPreset) => {
  return requestWithPromise(
    `/api/shift-presets/${shiftPreset.id}`,
    DELETE,
    null,
    user,
    true,
    true
  )
}

export const getAllShiftPresets = (user, parameters = {}) => {
  return requestWithPromise(
    `/api/shift-presets${makeQueryString(parameters)}`,
    GET,
    null,
    user
  )
}
